<template>
  <v-content>
    <section>
      <v-parallax 
        :src="require('@/assets/images/screen_01.jpg')" 
        height="400"
      >
        <v-layout
          column
          align-center
          justify-center
        >
          <h1 class="h_first_line">
            {{ $t('h_home_head_01') }}
          </h1>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-layout
        column
        wrap
        class="my-5"
        align-center
      >
        <v-flex 
          xs12 
          sm4 
          class="my-3"
        >
          <div class="h_second_line">
            <h2 class="headline">
              {{ $t('h_home_01') }}
            </h2>
          </div>
        </v-flex>
        <v-flex 
          xs12
        >
          <v-container 
            grid-list-xl
          >
            <v-layout 
              row 
              wrap 
              justify-center
            >
              <v-flex 
                xs12 
                md4
              >
                <v-card 
                  class="elevation-0 transparent"
                >
                  <v-card-text 
                    class="layout justify-center"
                  >
                    <v-icon 
                      x-large 
                      class="blue--text text--lighten-2"
                    >
                      fa-portrait
                    </v-icon>
                  </v-card-text>
                  <v-card-title 
                    primary-title 
                    class="layout justify-center "
                  >
                    <div class="h_second_line">
                      {{ $t('h_home_01_01') }}
                    </div>
                  </v-card-title>
                  <v-card-text class="p_text">
                    {{ $t('home_presentation') }}
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex 
                xs12 
                md4
              >
                <v-card 
                  class="elevation-0 transparent"
                >
                  <v-card-text 
                    class="layout justify-center"
                  >
                    <v-icon 
                      x-large 
                      class="blue--text text--lighten-2"
                    >
                      fa-newspaper
                    </v-icon>
                  </v-card-text>
                  <v-card-title 
                    primary-title 
                    class="layout justify-center"
                  >
                    <div class="h_second_line">
                      {{ $t('h_home_01_02') }}
                    </div>
                  </v-card-title>
                  <v-card-text class="p_text">
                    {{ $t('home_article') }} 
                  </v-card-text>
                </v-card>
              </v-flex>
              <v-flex 
                xs12 
                md4
              >
                <v-card 
                  class="elevation-0 transparent"
                >
                  <v-card-text 
                    class="layout justify-center"
                  >
                    <v-icon 
                      x-large 
                      class="blue--text text--lighten-2"
                    >
                      fa-calendar-check
                    </v-icon>
                  </v-card-text>
                  <v-card-title 
                    primary-title 
                    class="layout justify-center"
                  >
                    <div class="h_second_line">
                      {{ $t('h_home_01_03') }}
                    </div>
                  </v-card-title>
                  <v-card-text class="p_text">
                    {{ $t('home_events') }} 
                  </v-card-text>
                </v-card>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
    </section>

    <section>
      <v-parallax 
        :src="require('@/assets/images/screen_02.jpg')" 
        height="400"
      >
        <v-layout 
          column 
          align-center 
          justify-center
        >
          <div class="h_first_line">
            {{ $t('h_home_head_02') }}
          </div>
        </v-layout>
      </v-parallax>
    </section>

    <section>
      <v-container grid-list-xl>
        <v-layout 
          row 
          wrap 
          justify-center 
          class="my-5"
        >
          <v-flex 
            xs12 
            sm4
          >
            <v-card class="elevation-0 transparent">
              <v-card-title 
                primary-title 
                class="layout justify-center"
              >
                <div class="h_second_line">
                  {{ $t('h_home_02_01') }}
                </div>
              </v-card-title>
              <v-card-text class="p_text">
                {{ $t('home_info') }} 
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex 
            xs12 
            sm4 
            offset-sm1
          >
            <v-card class="elevation-0 transparent">
              <v-card-title 
                primary-title 
                class="layout justify-center"
              >
                <div class="h_second_line">
                  {{ $t('h_home_02_02') }}
                </div>
              </v-card-title>
              <v-card-text class="p_text">
                {{ $t('home_contact') }}
              </v-card-text>
              <v-list class="elevation-0 transparent">
                <template v-for="item in contactsMap">
                  <v-list-item :key="item.c_icon" @click="handleClick(item.c_link)">
                    <template v-slot:default="{ active, toggle }">
                      <v-list-item-action>
                        <v-icon class="blue--text text--lighten-2">
                          {{ item.c_icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title class="c_text">{{ item.c_text }}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
              </v-list>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </section>
  </v-content>
</template>

<script>
  export default {
    name: "home",
    computed:{
      contactsMap(){
        return this.$store.getters.getLM
      }
    },
    methods: {
      handleClick: function(target) {
        if (target.length != 0){
          this.$router.resolve({query: {data: "Certificate"}});
          window.open(target, '_blank');
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>